import { render } from "./ButttonLarge.vue?vue&type=template&id=1fed43f9"
import script from "./ButttonLarge.vue?vue&type=script&lang=js"
export * from "./ButttonLarge.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__